import * as React from 'react';

import { isNumber } from 'lodash-es';

import { IBackendCartEntries } from '@rbi-ctg/menu';

import { EntryDescriptionRow } from './cart-entry.styled';

const resolveEntryChild = (entry: IBackendCartEntries, currencyFormatter: Function) => {
  if (!entry.children) {
    return null;
  }

  const resolveChild = (child: IBackendCartEntries, i: number): React.ReactNode =>
    child?.children?.length ? (
      child.children.map(resolveChild)
    ) : (
      <EntryDescriptionRow key={child.name! + i}>
        {child.name}
        {isNumber(child.price) && ` - ${currencyFormatter(child.price)}`}
      </EntryDescriptionRow>
    );

  return entry.children.map(resolveChild);
};

export default resolveEntryChild;
